import Storage from '@aws-amplify/storage';
import useAsync from '@dyl/hooks/useAsync';

/**
 * @param {'images' | 'sounds'} type
 * @param {string} id
 * @param {Object} [options]
 * @param {number} [options.delay]
 * @returns {string | null}
 */
export default function useAssetUrl(type, id, { delay = 0 } = {}) {
    const src = useAsync(async () => {
        if (!id) return null;

        if (delay) await new Promise(resolve => setTimeout(resolve, delay));

        try {
            return await Storage.get(`${type}/${id}`, {
                level: 'public',
                customPrefix: { public: '' },
            });
        }
        catch (error) {
            console.error(`Failed to get ${type}/${id}: `, error);
            return null;
        }
    }, [type, id]) ?? null;

    return src;
}